import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Buefy from 'buefy'
import VueMq from 'vue-mq'
import SvgIcon from 'vue-svgicon'
import VueBreadcrumbs from 'vue-breadcrumbs'
import VueCroppie from 'vue-croppie'
import VueLazyload from 'vue-lazyload'
import './assets/svg'
import './assets/stylesheets/main.scss'
import './filters'
import VuePackeryPlugin from 'vue-packery-plugin'
import 'croppie/croppie.css'
import VueProgressBar from 'vue-progressbar'
import UrlManager from './plugins/UrlManager'

const options = {
  color: '#FF4545',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  position: 'relative',
  // location: 'left',
  inverse: false
}
Vue.use(<any>VueProgressBar, options)

import Geocoder from "@pderas/vue2-geocoder";
Vue.use(<any>Geocoder, {
  googleMapsApiKey: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
})

import _ from 'lodash'
Vue.use(<any>_)

Vue.use(Buefy)
Vue.use(VuePackeryPlugin)
Vue.use(<any>VueCroppie)

const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueLazyload)
Vue.use(<any>VueBreadcrumbs)
Vue.use(SvgIcon, {
  tagName: 'svgicon'
})
Vue.use(<any>VueMq, {
  breakpoints: {
    sm: 450,
    md: 1200,
    lg: 1500,
    xl: Infinity
  }
})
Vue.use(UrlManager, router)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
